const zoomButtons = document.querySelectorAll(".vase__img .optional__zoom");
const popup = document.getElementById("imagePopup");
const popupImg = popup.querySelector(".image-popup__img");

zoomButtons.forEach((btn) => {
  btn.addEventListener("click", (e) => {
    e.preventDefault(); // stops default browser action
    e.stopPropagation();
    const wrapper = btn.closest(".vase__img");
    const img = wrapper.querySelector("img");

    popupImg.src = img.src; // load same image
    popup.classList.add("active");
  });
});

// close on overlay click
popup.addEventListener("click", (e) => {
  if (
    e.target.classList.contains("image-popup__overlay") ||
    e.target === popup
  ) {
    popup.classList.remove("active");
    popupImg.src = "";
  }
});
